import { DELIMITER, LISTING_STATUSES } from '../constants/ClickstreamConstants';

export const getListingStatusSuffix = (isActive: boolean, dateLastActivatedTimestamp: string) => {
  if (isActive) {
    return `${DELIMITER}${LISTING_STATUSES.ACTIVE}`;
  }
  if (dateLastActivatedTimestamp !== '') {
    return `${DELIMITER}${LISTING_STATUSES.OFF_MARKET}`;
  }
  // new listing - do not append suffix to CS trigger location
  return '';
};
